import * as React from "react";
import { Modal, ModalFooter, Button } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { Form } from "@grandvisionhq/forms";
import { useAddressFormSlotsContext } from "../../../../../../slots/slots/AddressFormSlotsContext.js";
/* empty css                    */
const BillingAddress = (props) => {
  const {
    billingAddressData,
    closeEditMode,
    formState,
    handleFormChange,
    handleSaveBillingAddress,
    isUpdating,
    showEditButton,
    toggleEditMode,
    labels
  } = props;
  const {
    Slots: { form: FormTemplate, summary: SummaryTemplate }
  } = useAddressFormSlotsContext();
  return /* @__PURE__ */ React.createElement("div", { className: "billing-address" }, /* @__PURE__ */ React.createElement("p", null, labels.intro), /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen: !!formState?.inEditMode,
      onModalClose: closeEditMode,
      showIcon: true,
      title: labels.modalTitle,
      footer: /* @__PURE__ */ React.createElement(
        ModalFooter,
        {
          ctaCaption: labels.save,
          onCta: handleSaveBillingAddress,
          ctaLoading: isUpdating,
          onCancel: closeEditMode
        }
      ),
      className: "billing-address__modal"
    },
    /* @__PURE__ */ React.createElement(Text, null, labels.modalInfo),
    FormTemplate ? /* @__PURE__ */ React.createElement(
      Form,
      {
        name: "billingAddress",
        "data-t": "billingAddress",
        initialFormState: formState?.state?.formState,
        onChange: handleFormChange
      },
      /* @__PURE__ */ React.createElement(FormTemplate, null)
    ) : null,
    /* @__PURE__ */ React.createElement(Text, null, labels.note)
  ), Object.values(billingAddressData).every((x) => x === null || x === "") ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, null, labels.noAddress), showEditButton && /* @__PURE__ */ React.createElement(Button, { caption: labels.add, onClick: toggleEditMode })) : SummaryTemplate && /* @__PURE__ */ React.createElement(
    SummaryTemplate,
    {
      values: billingAddressData,
      actions: { onEdit: showEditButton ? toggleEditMode : void 0 }
    }
  ));
};
export {
  BillingAddress as default
};
//# sourceMappingURL=BillingAddress.js.map
